import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../../assets/website/images/logo.png";
import { useSelector } from "react-redux";

const SwayydHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const globalDetails = useSelector((state) => state.globalDetails?.data);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, target) => {
    if (isHome) {
      e.preventDefault();
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav className={`swayyd-nav ${scrolled ? "scrolled" : ""}`}>
      <Link to="/" className="nav-logo" style={{ textDecoration: "none" }}>
        <img className="w-10 h-10 border rounded-[9px] border-white" src={logo} alt="logo" />
      </Link>
      <ul className="nav-links">
        <li>
          <a href="/#features" onClick={(e) => handleNavClick(e, "#features")}>Features</a>
        </li>
        <li>
          <a href="/#bae" onClick={(e) => handleNavClick(e, "#bae")}>Bae!</a>
        </li>
        <li>
          <a href="/#faq" onClick={(e) => handleNavClick(e, "#faq")}>FAQ</a>
        </li>
        <li>
          <a href="/#contact" className="nav-cta" onClick={(e) => handleNavClick(e, "#contact")}>Contact us</a>
        </li>
      </ul>
    </nav>
  );
};

export default SwayydHeader;
